import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-action-agreement',
  templateUrl: './action-agreement.component.html'
})
export class ActionAgreementComponent {
  @Input() public action = 'By performing this action ';
}
